import type { Article } from './types';

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026年最值得关注的十大AI技术趋势：从大模型到具身智能',
    excerpt: '人工智能技术正在以前所未有的速度发展，从语言模型到多模态理解，再到具身智能，2026年有哪些技术趋势值得我们关注？本文为你详细解读。',
    content: `<p>人工智能技术在2026年迎来了新的发展高峰。随着计算能力的提升和算法的不断优化，AI正在渗透到我们生活的方方面面。</p>
<h2>1. 大语言模型的持续进化</h2>
<p>大语言模型（LLM）在2026年继续保持着强劲的发展势头。新一代模型不仅在参数量上有所突破，更重要的是在推理能力、多模态理解和上下文长度方面取得了显著进展。开源社区的蓬勃发展使得更多开发者能够参与到模型的优化和应用中来。</p>
<p>值得关注的是，模型的小型化和边缘部署成为了新的趋势。通过知识蒸馏和量化技术，原本需要大量计算资源的模型现在可以在移动设备上流畅运行，这为AI的普及应用打开了新的大门。</p>
<h2>2. 多模态AI的成熟应用</h2>
<p>多模态AI技术已经不再是实验室中的概念。2026年，我们看到了大量能够同时处理文本、图像、音频和视频的AI应用出现在市场中。从智能文档处理到创意内容生成，多模态AI正在重新定义人机交互的方式。</p>
<h2>3. 具身智能的突破</h2>
<p>具身智能（Embodied AI）在机器人领域的应用取得了突破性进展。新一代的人形机器人不仅能够完成复杂的物理操作，还具备了环境感知和自主学习的能力。这标志着AI正在从虚拟世界走向物理世界。</p>
<h2>4. AI安全与伦理治理</h2>
<p>随着AI技术的广泛应用，安全与伦理问题也越来越受到关注。各国政府和国际组织正在积极推动AI治理框架的建立，确保AI技术的发展能够造福全人类。</p>
<h2>结语</h2>
<p>2026年是AI技术发展的关键一年。这些趋势不仅代表了技术的进步方向，更反映了整个行业对于AI未来发展的共同期待。作为技术爱好者和从业者，我们需要持续关注这些变化，积极拥抱AI带来的机遇。</p>`,
    category: '科技数码',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20AI%20technology%20concept%20with%20digital%20brain%20circuit%20board%20and%20glowing%20neural%20network%20connections%2C%20futuristic%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20clean%20tech%20aesthetic%2C%20professional%20editorial%20photography%20style%20with%20soft%20gradients%20and%20subtle%20depth%20of%20field&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '科技观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20tech%20blogger%20with%20glasses%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20modern%20casual%20style%2C%20soft%20studio%20lighting%2C%20editorial%20portrait%20photography&width=100&height=100&seq=avatar-01&orientation=squarish',
    publishDate: '2026-08-06',
    readCount: 15280,
    likeCount: 892,
    commentCount: 156,
    tags: ['人工智能', '科技趋势', '大模型', 'AI'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 'article-2',
    title: '探店成都最隐蔽的宝藏小店：深巷里的地道川味',
    excerpt: '在成都的深巷中，隐藏着无数令人惊艳的美食小店。跟随我们的脚步，一起探寻那些不为游客所知的本地人私藏美食。',
    content: `<p>成都，这座以美食闻名的城市，不仅有宽窄巷子和锦里这样的热门景点，更有无数藏在深巷中的地道美食。今天，就让我们一起走进成都的街巷深处，探寻那些本地人心中的宝藏小店。</p>
<h2>老成都的味道记忆</h2>
<p>在玉林路的一条不起眼的小巷里，藏着一家开了二十多年的老店。没有华丽的招牌，只有门口排着长队的人们。这里的担担面，芝麻酱浓郁醇厚，配上现炒的肉末和秘制辣椒油，每一口都是成都最地道的味道。</p>
<p>老板张师傅说，他每天凌晨四点就开始准备，坚持用传统工艺手工制作面条。"机器做的面没有灵魂，"他笑着说，"手工揉出来的面才有嚼劲。"</p>
<h2>隐藏在菜市场里的美味</h2>
<p>青石桥菜市场二楼，有一家连导航都找不到的小店。这里的肥肠粉，用的是当天清晨现杀的猪肠，清洗得干干净净，配上红油和花椒，麻辣鲜香，一碗下肚，整个上午都精神抖擞。</p>
<h2>深夜食堂的温暖</h2>
<p>凌晨两点，当大多数店铺都已经打烊，牛市口的一家小店依然灯火通明。一碗热气腾腾的蹄花汤，是这座城市给夜归人最好的慰藉。</p>
<h2>结语</h2>
<p>成都的美食文化，不仅仅是那些米其林星级餐厅，更多的是这些隐藏在街头巷尾的小店。它们承载着这座城市最真实的味道和最温暖的人情。下次来成都，不妨走进一条不起眼的小巷，说不定就能发现属于你的味蕾惊喜。</p>`,
    category: '美食旅行',
    categorySlug: 'food-travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20Sichuan%20street%20food%20in%20Chengdu%20alley%2C%20steaming%20hot%20noodles%20in%20bowl%20with%20red%20chili%20oil%2C%20rustic%20wooden%20table%2C%20warm%20ambient%20light%2C%20authentic%20local%20restaurant%20atmosphere%2C%20editorial%20food%20photography%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '美食猎人小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20female%20food%20blogger%20with%20warm%20smile%2C%20clean%20cream%20background%2C%20casual%20elegant%20style%2C%20soft%20natural%20studio%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    publishDate: '2026-08-05',
    readCount: 23450,
    likeCount: 1567,
    commentCount: 289,
    tags: ['成都美食', '探店', '川菜', '地道小吃'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 'article-3',
    title: '年度必看！2026下半年最值得期待的五部华语电影',
    excerpt: '从文艺片到商业大片，2026年下半年华语电影市场精彩纷呈。我们为你精选了五部不容错过的重磅作品。',
    content: `<p>2026年的华语电影市场持续回温，下半年将有多部备受瞩目的作品陆续上映。无论你是文艺片爱好者还是商业大片的忠实粉丝，这份片单都值得收藏。</p>
<h2>1. 《山河故人2》</h2>
<p>贾樟柯导演时隔多年带来的续作，延续了前作对时代变迁的深刻思考。影片以一个普通家庭三代人的命运变迁为线索，展现了中国社会近四十年的巨大变革。赵涛、张译等实力派演员的精彩演绎令人期待。</p>
<h2>2. 《深海之光》</h2>
<p>国产科幻动画电影的又一力作。这部由《深海》原班人马打造的作品，讲述了一个关于勇气与希望的深海冒险故事。影片在视觉效果上达到了新的高度，每一帧画面都堪称艺术品。</p>
<h2>3. 《长安十二时辰》电影版</h2>
<p>改编自马伯庸同名小说的电影版终于来了。曹盾导演携手原班人马，将这部备受好评的剧集搬上了大银幕。更加精良的制作和更加紧凑的叙事，让这部作品成为了下半年最受期待的商业大片之一。</p>
<h2>4. 《野草》</h2>
<p>新人导演李小满的处女作，在多个国际电影节上斩获大奖。这部黑白电影以极简的叙事风格，讲述了一个乡村女孩在城市中寻找自我价值的故事。影片的诗意和力量感令人动容。</p>
<h2>5. 《功夫2》</h2>
<p>周星驰时隔多年再次执导功夫题材电影。虽然目前保密工作做得极好，但仅凭星爷的金字招牌，这部作品就已经成为了2026年最受关注的华语电影之一。</p>`,
    category: '电影音乐',
    categorySlug: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20golden%20lighting%2C%20red%20velvet%20seats%2C%20large%20blank%20screen%20with%20subtle%20glow%2C%20elegant%20classic%20cinema%20aesthetic%2C%20atmospheric%20mood%2C%20editorial%20interior%20photography&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '影评人老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Chinese%20man%20film%20critic%2C%20clean%20gray%20background%2C%20thoughtful%20expression%2C%20casual%20intellectual%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    publishDate: '2026-08-04',
    readCount: 18920,
    likeCount: 1234,
    commentCount: 203,
    tags: ['华语电影', '电影推荐', '院线大片', '影评'],
    isFeatured: true,
    isHot: false,
  },
  {
    id: 'article-4',
    title: '家庭健身完全指南：零器械打造完美身材',
    excerpt: '不需要昂贵的健身房会员，也不需要复杂的器械。这份家庭健身指南教你如何利用自身体重，在家轻松练出好身材。',
    content: `<p>随着生活节奏的加快，越来越多的人选择在家进行健身锻炼。不需要昂贵的器械，不需要宽敞的空间，利用自身体重就能完成高效的全身训练。今天，我们就来分享一套完整的家庭健身方案。</p>
<h2>为什么选择家庭健身？</h2>
<p>家庭健身最大的优势在于灵活性和私密性。你可以在任何时间开始训练，不受健身房营业时间的限制。此外，家庭健身还能帮你节省大量的通勤时间和会员费用。</p>
<h2>基础动作篇</h2>
<p><strong>俯卧撑</strong>：最经典的上肢训练动作。标准俯卧撑主要锻炼胸肌、三角肌前束和肱三头肌。初学者可以从跪姿俯卧撑开始，逐步过渡到标准俯卧撑。</p>
<p><strong>深蹲</strong>：下肢训练的王者动作。正确的深蹲姿势可以有效锻炼股四头肌、臀大肌和核心肌群。注意保持背部挺直，膝盖不要超过脚尖。</p>
<p><strong>平板支撑</strong>：核心训练的黄金动作。建议从30秒开始，逐步增加到2分钟以上。</p>
<h2>一周训练计划</h2>
<p>周一：上肢训练（俯卧撑、钻石俯卧撑、宽距俯卧撑）</p>
<p>周三：下肢训练（深蹲、弓步蹲、臀桥）</p>
<p>周五：核心训练（平板支撑、仰卧卷腹、俄罗斯转体）</p>
<p>周末：轻度有氧运动或休息</p>
<h2>饮食建议</h2>
<p>健身三分练七分吃。建议增加蛋白质摄入，控制精制碳水化合物的摄入量，多食用蔬菜和水果。保持充足的水分摄入也很重要。</p>`,
    category: '运动健身',
    categorySlug: 'sports',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20home%20gym%20space%20with%20yoga%20mat%20on%20wooden%20floor%2C%20warm%20natural%20sunlight%20streaming%20through%20window%2C%20indoor%20plants%2C%20clean%20modern%20aesthetic%2C%20calm%20and%20peaceful%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '健身教练阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20fit%20Chinese%20male%20fitness%20coach%2C%20clean%20white%20background%2C%20confident%20smile%2C%20athletic%20style%2C%20bright%20studio%20lighting&width=100&height=100&seq=avatar-04&orientation=squarish',
    publishDate: '2026-08-03',
    readCount: 31200,
    likeCount: 2156,
    commentCount: 345,
    tags: ['健身', '家庭锻炼', '运动指南', '健康生活'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 'article-5',
    title: '高效学习法：如何在30天内掌握一门新技能',
    excerpt: '学习新技能不一定要花很长时间。掌握正确的方法，你可以在30天内入门任何领域。本文分享经过验证的高效学习策略。',
    content: `<p>在当今快速变化的世界中，持续学习新技能已经成为每个人的必修课。但很多人觉得学习新东西需要投入大量时间，其实不然。通过科学的学习方法，你可以在30天内实现从零到入门的突破。</p>
<h2>制定清晰的学习目标</h2>
<p>模糊的目标带来模糊的结果。在开始学习之前，你需要明确回答三个问题：我要学什么？学到什么程度？用多长时间？将大目标分解成每天可以完成的小任务，这样才能保持持续的动力。</p>
<h2>费曼学习法</h2>
<p>诺贝尔物理学奖得主理查德·费曼提出了一种极为高效的学习方法：用简单的语言向他人解释你正在学习的内容。如果你无法用通俗易懂的方式讲清楚一个概念，说明你还没有真正理解它。</p>
<h2>番茄工作法</h2>
<p>25分钟专注学习，5分钟休息，这是一个番茄钟。每完成4个番茄钟后，进行一次较长的休息（15-30分钟）。这种方法可以有效防止疲劳，保持高效的学习状态。</p>
<h2>间隔重复</h2>
<p>遗忘是学习最大的敌人。科学研究表明，间隔重复是巩固记忆最有效的方法。建议在学习新知识后的1天、3天、7天、14天和30天分别进行复习。</p>
<h2>实践与反馈</h2>
<p>"学习金字塔"理论告诉我们，被动阅读只能保留约10%的信息，而主动实践和教授他人可以保留90%以上。因此，在学习过程中，要尽可能多地创造实践机会，并及时获取反馈进行调整。</p>`,
    category: '学习教育',
    categorySlug: 'education',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20study%20desk%20with%20open%20notebook%20and%20warm%20desk%20lamp%2C%20books%20stacked%20neatly%2C%20coffee%20cup%2C%20soft%20natural%20light%20from%20window%2C%20peaceful%20learning%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '学习达人小陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20female%20student%20with%20glasses%2C%20clean%20white%20background%2C%20bright%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-05&orientation=squarish',
    publishDate: '2026-08-02',
    readCount: 27500,
    likeCount: 1876,
    commentCount: 312,
    tags: ['学习方法', '技能提升', '效率', '自我成长'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 'article-6',
    title: '数码爱好者必入：2026年最值得购买的5款真无线耳机',
    excerpt: '真无线耳机市场竞争激烈，从入门到旗舰，我们为你精选了2026年最值得购买的五款产品，覆盖不同预算和需求。',
    content: `<p>真无线耳机已经成为现代人生活中不可或缺的数码配件。2026年的真无线耳机市场更加成熟，各大品牌纷纷推出了功能更强大、音质更出色的新品。今天我们就来盘点五款最值得购买的真无线耳机。</p>
<h2>1. 苹果 AirPods Pro 3</h2>
<p>苹果最新一代的旗舰真无线耳机，在降噪性能和音质表现上都达到了新的高度。全新的H3芯片带来了更快的连接速度和更低的延迟。自适应音频功能可以根据环境自动调整降噪强度，使用体验更加智能。</p>
<h2>2. 索尼 WF-1000XM6</h2>
<p>索尼在音频领域的技术积累毋庸置疑。XM6延续了索尼一贯的优秀降噪性能，同时在音质调校上更加均衡。支持LDAC高清音频传输，是音乐爱好者的首选。</p>
<h2>3. 华为 FreeBuds Pro 4</h2>
<p>华为的真无线耳机在通话降噪方面一直是行业标杆。FreeBuds Pro 4在保持优秀通话质量的同时，音质和主动降噪性能也大幅提升。星闪连接技术带来了更稳定的连接体验。</p>
<h2>4. 三星 Galaxy Buds3 Pro</h2>
<p>三星的这款产品在设计上更加时尚，佩戴舒适度极佳。AKG调校的音质表现可圈可点，360度空间音频功能让观影体验更加沉浸。</p>
<h2>5. 小米 Buds 5 Pro</h2>
<p>作为性价比之王，小米的这款产品在500元价位段几乎没有对手。支持主动降噪、无线充电和IPX5防水，功能齐全且价格亲民。</p>`,
    category: '科技数码',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Premium%20wireless%20earbuds%20displayed%20on%20minimalist%20white%20surface%2C%20modern%20product%20photography%20with%20soft%20shadows%2C%20clean%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20editorial%20style%20with%20elegant%20composition&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '数码达人小林',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20male%20tech%20reviewer%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20modern%20casual%20style%2C%20bright%20studio%20lighting&width=100&height=100&seq=avatar-06&orientation=squarish',
    publishDate: '2026-08-01',
    readCount: 20340,
    likeCount: 1102,
    commentCount: 198,
    tags: ['真无线耳机', '数码产品', '耳机推荐', '科技评测'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 'article-7',
    title: '都市人的解压指南：五个简单方法找回内心平静',
    excerpt: '在快节奏的都市生活中，压力无处不在。分享五个经过验证的解压方法，帮助你在繁忙的生活中找到片刻宁静。',
    content: `<p>生活在大都市的人们，每天都在与时间赛跑。工作压力、人际关系、生活琐事，种种因素让我们的神经时刻处于紧绷状态。长期的慢性压力不仅影响工作效率，更会对身心健康造成严重伤害。</p>
<h2>1. 正念冥想</h2>
<p>每天只需10分钟的正念冥想，就能显著降低焦虑水平。找一个安静的地方，闭上眼睛，将注意力集中在呼吸上。当思绪飘走时，温柔地将其拉回。这不是要清空大脑，而是学会观察自己的思绪而不被其裹挟。</p>
<h2>2. 数字断舍离</h2>
<p>我们的手机里充斥着各种信息和通知，这些看似无害的碎片信息其实在持续消耗我们的注意力资源。尝试每天固定时间段远离手机，让自己从数字世界中暂时抽离出来。</p>
<h2>3. 亲近自然</h2>
<p>研究表明，每周在自然环境中度过至少2小时的人，身心健康状况明显优于其他人。即使是城市中的一个小公园，也能带来显著的减压效果。找个周末，去郊外走走，呼吸新鲜空气。</p>
<h2>4. 创造性表达</h2>
<p>写日记、画画、弹琴、做手工——任何形式的创造性活动都能帮助我们释放情绪。你不需要成为艺术家，重要的是享受创造的过程本身。</p>
<h2>5. 建立社交连接</h2>
<p>孤独感是压力的重要来源之一。主动与朋友、家人保持联系，分享你的感受和经历。即使是简单的一通电话或一次咖啡约会，也能带来巨大的情感支持。</p>`,
    category: '生活娱乐',
    categorySlug: 'lifestyle',
    coverImage: 'https://readdy.ai/api/search-image?query=Serene%20minimalist%20bedroom%20with%20soft%20morning%20sunlight%2C%20white%20linen%20bedding%2C%20small%20indoor%20plant%2C%20aroma%20diffuser%20with%20gentle%20mist%2C%20calm%20and%20peaceful%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '心理咨询师小美',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20female%20therapist%20with%20warm%20gentle%20smile%2C%20clean%20cream%20background%2C%20professional%20yet%20approachable%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-07&orientation=squarish',
    publishDate: '2026-07-31',
    readCount: 35600,
    likeCount: 2890,
    commentCount: 467,
    tags: ['解压', '心理健康', '生活方式', '冥想'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 'article-8',
    title: '日本关西深度游攻略：大阪京都奈良七日完美行程',
    excerpt: '第一次去日本关西不知道怎么玩？这份七日深度游攻略涵盖了大阪、京都和奈良的精华景点与地道美食，让你的旅行不留遗憾。',
    content: `<p>日本关西地区是许多旅行者心中的梦想目的地。大阪的美食、京都的古韵、奈良的鹿群，每一个城市都有独特的魅力。这份七日深度游攻略将帮助你充分利用时间，体验关西最精彩的一面。</p>
<h2>Day 1-2：大阪——美食与活力之城</h2>
<p>抵达大阪后，建议先前往心斋桥和道顿堀感受这座城市的活力。章鱼烧、大阪烧、串炸——这里的美食绝对让你流连忘返。第二天可以前往大阪城公园，登上天守阁俯瞰城市全景，然后去环球影城体验世界级的主题乐园。</p>
<h2>Day 3-5：京都——千年古都的韵味</h2>
<p>从大阪乘坐JR线约30分钟即可到达京都。建议安排三天时间慢慢品味这座古都。伏见稻荷大社的千本鸟居、清水寺的绝美夕阳、金阁寺的庄严辉煌——每一处都值得细细游览。不要错过岚山的竹林小径和天龙寺的枯山水庭院。</p>
<h2>Day 6：奈良——与小鹿的亲密接触</h2>
<p>奈良公园的鹿是这座城市最可爱的名片。买一包鹿仙贝，与这些自由漫步的小鹿互动。东大寺的大佛殿是世界上最大的木造建筑，其雄伟壮观令人震撼。</p>
<h2>Day 7：返回大阪，购物与返程</h2>
<p>最后一天回到大阪，在心斋桥和梅田商圈尽情购物。别忘了在关西国际机场的免税店补货后，带着满满的回忆踏上归途。</p>
<h2>实用贴士</h2>
<p>建议购买JR关西周游券，可以无限次乘坐JR线路，非常划算。住宿方面，大阪推荐住在难波或梅田区域，京都推荐住在京都站附近，交通最为便利。</p>`,
    category: '美食旅行',
    categorySlug: 'food-travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20Japanese%20temple%20in%20Kyoto%20with%20cherry%20blossom%20trees%2C%20warm%20golden%20sunset%20light%2C%20pagoda%20silhouette%2C%20serene%20atmosphere%2C%20travel%20photography%20with%20rich%20cultural%20texture&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '旅行博主阿琳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20female%20travel%20blogger%2C%20clean%20white%20background%2C%20adventurous%20smile%2C%20casual%20outdoor%20style%2C%20bright%20natural%20studio%20lighting&width=100&height=100&seq=avatar-08&orientation=squarish',
    publishDate: '2026-07-30',
    readCount: 42100,
    likeCount: 3120,
    commentCount: 534,
    tags: ['日本旅行', '关西攻略', '京都', '自由行'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 'article-9',
    title: '古典音乐入门指南：从零开始听懂交响乐',
    excerpt: '古典音乐并不高冷。这份入门指南帮你了解交响乐的基本构成，推荐适合初学者的经典曲目，让你轻松走进古典音乐的世界。',
    content: `<p>很多人觉得古典音乐难以接近，其实这是一种误解。古典音乐就像一门语言，一旦你掌握了基本的"词汇"和"语法"，就能感受到其中蕴含的丰富情感和无穷魅力。</p>
<h2>认识交响乐团</h2>
<p>一个标准的交响乐团由四个乐器组组成：弦乐组（小提琴、中提琴、大提琴、低音提琴）、木管组（长笛、双簧管、单簧管、巴松管）、铜管组（小号、圆号、长号、大号）和打击乐组（定音鼓、钹、三角铁等）。了解这些乐器的音色特点，是理解交响乐的第一步。</p>
<h2>交响曲的基本结构</h2>
<p>典型的古典交响曲通常由四个乐章组成：第一乐章（快板，奏鸣曲式）、第二乐章（慢板，抒情优美）、第三乐章（舞曲风格，通常是三拍子）、第四乐章（快板，辉煌的终曲）。</p>
<h2>入门推荐曲目</h2>
<p><strong>贝多芬第五交响曲《命运》</strong>：那四个著名的音符"当当当当"可能是古典音乐中最广为人知的旋律。</p>
<p><strong>莫扎特第40号交响曲</strong>：旋律优美动听，充满了莫扎特式的优雅与哀愁。</p>
<p><strong>德沃夏克第九交响曲《自新大陆》</strong>：融合了美国民间音乐元素，第二乐章的"念故乡"旋律催人泪下。</p>
<p><strong>柴可夫斯基第六交响曲《悲怆》</strong>：情感浓烈，是浪漫主义交响曲的巅峰之作。</p>`,
    category: '电影音乐',
    categorySlug: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20symphony%20orchestra%20performing%20on%20stage%2C%20warm%20golden%20stage%20lighting%2C%20violinists%20in%20focus%2C%20grand%20concert%20hall%20atmosphere%2C%20classical%20music%20performance%2C%20editorial%20photography%20with%20dramatic%20lighting&width=800&height=450&seq=article-cover-09&orientation=landscape',
    author: '音乐编辑阿明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20male%20music%20critic%2C%20clean%20gray%20background%2C%20artistic%20expression%2C%20creative%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-09&orientation=squarish',
    publishDate: '2026-07-29',
    readCount: 12400,
    likeCount: 756,
    commentCount: 123,
    tags: ['古典音乐', '交响乐', '音乐入门', '文化'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 'article-10',
    title: '跑者进阶指南：从5公里到全程马拉松的训练计划',
    excerpt: '已经能轻松跑完5公里，想要挑战更长的距离？这份循序渐进的训练计划，帮助你安全高效地实现全程马拉松的目标。',
    content: `<p>完成了人生第一个5公里，恭喜你已经迈出了成为跑者的重要一步。现在，是时候向更远的距离发起挑战了。无论是10公里、半程马拉松还是全程马拉松，科学的训练计划都是你最好的伙伴。</p>
<h2>训练的基本原则</h2>
<p>循序渐进是跑步训练中最重要的一条原则。每周增加的跑量不应超过上周的10%，这样可以给身体足够的时间适应，减少受伤风险。此外，轻松跑应该占据每周总跑量的80%左右，只有约20%是速度训练。</p>
<h2>从5公里到10公里（4周计划）</h2>
<p>第1周：保持每周3次跑步，将最长的一次增加到6公里</p>
<p>第2周：最长距离增加到7公里</p>
<p>第3周：最长距离增加到8公里</p>
<p>第4周：挑战10公里</p>
<h2>从10公里到半程马拉松（8周计划）</h2>
<p>这个阶段需要引入长距离慢跑（LSD），每周进行一次。从12公里开始，每两周增加2公里，直到在比赛前两周完成一次18-20公里的长距离跑。</p>
<h2>从半马到全马（12周计划）</h2>
<p>全马训练需要更多的时间和精力投入。除了继续增加长距离跑的里程（最高到32-35公里），还需要加入节奏跑和间歇跑等速度训练。同时，力量训练和充足的恢复也同样重要。</p>
<h2>营养与补给</h2>
<p>长距离跑步对能量消耗巨大。建议在跑步前2-3小时摄入易消化的碳水化合物。跑步超过1小时需要在运动中补给能量胶或运动饮料。跑后30分钟内摄入蛋白质有助于肌肉恢复。</p>`,
    category: '运动健身',
    categorySlug: 'sports',
    coverImage: 'https://readdy.ai/api/search-image?query=Runner%20on%20scenic%20trail%20during%20golden%20hour%20sunrise%2C%20athletic%20silhouette%20against%20warm%20morning%20sky%2C%20mountain%20landscape%20background%2C%20fitness%20lifestyle%20photography%2C%20inspirational%20outdoor%20sports%20aesthetic&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '跑步教练大刘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20male%20running%20coach%2C%20clean%20white%20background%2C%20energetic%20smile%2C%20sporty%20style%2C%20bright%20studio%20lighting&width=100&height=100&seq=avatar-10&orientation=squarish',
    publishDate: '2026-07-28',
    readCount: 18900,
    likeCount: 987,
    commentCount: 167,
    tags: ['跑步', '马拉松', '训练计划', '运动'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 'article-11',
    title: '职场新人必读：如何高效管理时间与提升工作效率',
    excerpt: '刚刚步入职场的新人常常面临时间管理的困惑。本文分享实用的时间管理技巧和效率提升方法，助你快速适应职场节奏。',
    content: `<p>从校园到职场，最大的转变之一就是时间管理方式的改变。在学校里，课程表帮你安排好了大部分时间；而在职场中，你需要自己规划和分配时间。掌握高效的时间管理技巧，是职场新人的必修课。</p>
<h2>艾森豪威尔矩阵</h2>
<p>将任务按照重要性和紧急性分为四个象限：重要且紧急（立即处理）、重要不紧急（规划时间处理）、紧急不重要（委托他人）、不重要不紧急（删除或推迟）。这个简单的框架能帮你理清优先级。</p>
<h2>番茄工作法的职场应用</h2>
<p>25分钟专注工作，5分钟短暂休息。研究表明，人的注意力集中时间大约在25-30分钟左右。使用番茄工作法可以帮助你保持高效的工作状态，避免长时间工作带来的疲劳和效率下降。</p>
<h2>深度工作 vs 浅层工作</h2>
<p>卡尔·纽波特在《深度工作》一书中指出，能够创造最大价值的是需要高度专注的"深度工作"，而不是频繁切换任务的"浅层工作"。建议每天安排2-3小时的深度工作时间，关闭所有通知，专注于最重要的任务。</p>
<h2>周计划与日回顾</h2>
<p>每周日晚上花15分钟规划下周的工作重点，每天早上花5分钟回顾当天的任务清单。这个简单的习惯可以让你始终保持在正确的轨道上，避免被琐事牵着走。</p>`,
    category: '学习教育',
    categorySlug: 'education',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20desk%20with%20laptop%20and%20notebook%2C%20warm%20morning%20light%20from%20window%2C%20clean%20organized%20workspace%2C%20indoor%20plant%2C%20professional%20yet%20cozy%20atmosphere%2C%20editorial%20workspace%20photography&width=800&height=450&seq=article-cover-11&orientation=landscape',
    author: '职场导师李姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20female%20business%20mentor%2C%20clean%20white%20background%2C%20confident%20professional%20smile%2C%20business%20casual%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-11&orientation=squarish',
    publishDate: '2026-07-27',
    readCount: 22100,
    likeCount: 1345,
    commentCount: 245,
    tags: ['职场', '时间管理', '效率提升', '新人指南'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 'article-12',
    title: '极简主义生活实践：一年断舍离后的真实感悟',
    excerpt: '践行极简主义一年后，作者分享了她的真实体验和感悟。从物品整理到心态转变，极简生活带来的改变远超预期。',
    content: `<p>一年前，我开始了极简主义的实践之旅。起因很简单——搬家时被堆积如山的物品吓到了。一年后的今天，我想分享这段经历中最真实的感悟。</p>
<h2>第一阶段：物品断舍离（第1-3个月）</h2>
<p>最初的三个月是最痛苦的。打开衣柜，面对那些"以后可能会穿"但已经两年没碰过的衣服，每一件都似乎有留下的理由。但我坚持了一个原则：过去一年没用过的东西，要么送人，要么扔掉。</p>
<p>处理掉了大约60%的衣物、80%的厨房小工具、和数不清的"纪念品"后，我的房间第一次有了呼吸感。</p>
<h2>第二阶段：消费习惯的改变（第4-6个月）</h2>
<p>当物品减少后，我对消费的态度发生了根本改变。购物前会问自己三个问题：我真的需要它吗？没有它我的生活会受影响吗？它值得占用我的空间吗？大多数时候，答案都是"不"。</p>
<h2>第三阶段：心态的转变（第7-12个月）</h2>
<p>极简主义不仅仅关乎物品，更是一种生活态度。我开始学会拒绝不必要的社交邀约，把时间留给真正重要的人和事。信息的极简也同样重要——取关了90%的公众号，退出了大多数微信群。</p>
<h2>一年后的感悟</h2>
<p>极简生活最大的收获不是省了多少钱，而是获得了更多的自由和专注力。当生活不再被物品和杂事填满，反而有了更多空间去做真正想做的事。</p>`,
    category: '生活娱乐',
    categorySlug: 'lifestyle',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20living%20room%20with%20scandinavian%20design%2C%20white%20walls%2C%20wooden%20floor%2C%20few%20carefully%20chosen%20decor%20items%2C%20warm%20natural%20sunlight%2C%20clean%20and%20serene%20atmosphere%2C%20editorial%20interior%20photography&width=800&height=450&seq=article-cover-12&orientation=landscape',
    author: '生活家小静',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20female%20lifestyle%20writer%2C%20clean%20cream%20background%2C%20serene%20smile%2C%20simple%20elegant%20style%2C%20soft%20natural%20studio%20lighting&width=100&height=100&seq=avatar-12&orientation=squarish',
    publishDate: '2026-07-26',
    readCount: 28900,
    likeCount: 2340,
    commentCount: 389,
    tags: ['极简主义', '断舍离', '生活方式', '整理'],
    isFeatured: false,
    isHot: true,
  },
];

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
}